import type { Form, FormField } from "./apiMarketing";

const field = (
  name: string,
  label: string,
  field_type: FormField["field_type"],
  crm_field?: string,
): FormField => ({
  name,
  label,
  field_type,
  crm_field,
  required: true,
  order: 0,
  width: "full",
});
export const formTemplates = [
  "Quote request",
  "Roof inspection",
  "Storm damage",
  "Service request",
].map((name) => ({
  name,
  fields: [
    field("full_name", "Your name", "text", "contact.full_name"),
    field("email", "Email address", "email", "contact.email"),
    field("phone", "Phone number", "phone", "contact.phone"),
    field("address", "Property address", "text", "address.full_address"),
    {
      ...field(
        "details",
        name === "Storm damage"
          ? "When did the storm occur and what damage have you noticed?"
          : name === "Roof inspection"
            ? "What would you like us to inspect?"
            : name === "Service request"
              ? "How can we help with your roof?"
              : "Tell us about your roofing project",
        "textarea",
      ),
      required: false,
    },
  ].map((item, order) => ({ ...item, order, id: `${name}-${item.name}` })),
}));

export function publishingIssues(form: Partial<Form>): string[] {
  const fields = form.form_schema?.fields || [];
  const issues: string[] = [];
  if (!fields.length) issues.push("Add at least one input field.");
  if (
    fields.some(
      (f) =>
        f.field_type === "file" ||
        Object.keys(f.conditional_logic || {}).length,
    )
  )
    issues.push(
      "File uploads and conditional rules are not supported in public forms. Remove these before publishing.",
    );
  if (
    !fields.some(
      (f) =>
        f.required &&
        !["heading", "divider", "paragraph"].includes(f.field_type),
    )
  )
    issues.push("Choose at least one required field.");
  if (
    form.create_contact &&
    !fields.some((f) => f.crm_field === "contact.email" && f.required)
  )
    issues.push(
      "Map a required email field to CRM email so submissions can create contacts.",
    );
  if (
    form.submit_action !== "message" &&
    !/^https?:\/\//i.test(form.submit_action_value || "")
  )
    issues.push("Provide a full HTTP or HTTPS URL for the success action.");
  if (form.email_notification_enabled && !form.email_notification_to?.length)
    issues.push(
      "Notifications use organization administrators, then the organization email. Check that these are current.",
    );
  if (form.status !== "active")
    issues.push(
      "This form is a draft or archived. Activate it when ready for visitors.",
    );
  return issues.length
    ? issues
    : [
        "Ready to publish. Test the form below and verify your notification recipients.",
      ];
}
